import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ZoneModule} from '../zone/zone.module';
import {ActiviteitHeaderComponent} from './activiteit-header/activiteit-header.component';
import {ActiviteitCardComponent} from './activiteit-card/activiteit-card.component';
import {ActiviteitTypeIconPipe} from './activiteid-type-icon.pipe';
import {ActiviteitTypePipe} from './activiteid-type.pipe';
import {ActiviteitenNavigatieComponent} from './activiteiten-navigatie/activiteiten-navigatie.component';
import {ActiviteitenComponent} from './activiteiten/activiteiten.component';
import {ActiviteitListItemComponent} from './activiteit-list-item/activiteit-list-item.component';

@NgModule({
  declarations: [
    ActiviteitHeaderComponent,
    ActiviteitenComponent,
    ActiviteitenNavigatieComponent,
    ActiviteitListItemComponent,
    ActiviteitCardComponent,
    ActiviteitTypeIconPipe,
    ActiviteitTypePipe,
  ],
  imports: [
    CoreModule,
    ZoneModule,
  ],
  exports: [
    ActiviteitHeaderComponent,
    ActiviteitenComponent,
    ActiviteitTypeIconPipe,
    ActiviteitTypePipe,
  ],
})
export class ActiviteitModule {
}
